import React, { ReactNode, useContext } from 'react';

export const DEFAULT_TRANSLATION_NAMESPACE = 'common';

type Context = {
  namespace?: string;
};

export const TranslateContext = React.createContext<Context>({
  namespace: DEFAULT_TRANSLATION_NAMESPACE,
});

export type Props = {
  children: ReactNode;
  namespace: string;
};
export default function TranslationWrapper({ children, namespace }: Props) {
  return (
    <TranslateContext.Provider value={{ namespace: namespace || DEFAULT_TRANSLATION_NAMESPACE }}>
      {children}
    </TranslateContext.Provider>
  );
}

export function useNamespace() {
  return useContext(TranslateContext).namespace || DEFAULT_TRANSLATION_NAMESPACE;
}
